import { render, staticRenderFns } from "./Training.vue?vue&type=template&id=7450aae2&scoped=true"
import script from "./Training.vue?vue&type=script&lang=js"
export * from "./Training.vue?vue&type=script&lang=js"
import style0 from "./Training.vue?vue&type=style&index=0&id=7450aae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7450aae2",
  null
  
)

export default component.exports